<svg
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 32 32"
  aria-hidden="true"
  focusable="false"
>
  <path
    d="M22.8 17.8 27.6 21.1M21.3 19.4 25 24M19.3 20.9 21.7 26M17.1 21.5 18 27.1M14.9 21.5 14 27.1M12.7 20.9 10.3 26M10.7 19.4 7 24M9.2 17.8 4.4 21.1"
  />
  <circle class="head" cx="16" cy="13" r="9" />
  <circle class="eye" cx="12.6" cy="11.5" r="1.6" />
  <circle class="eye" cx="19.4" cy="11.5" r="1.6" />
  <path class="smile" d="M12.4 16.2Q16 19.4 19.6 16.2" stroke-width="2" />
</svg>
